import { Component, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isReusablePaymentMethodType, PaymentMethodType, WalletPaymentMethodType } from '@platform-frontend/marketplace';
import { AddPaymentMethodService } from '../add-payment-method.service';

@Component({
  selector: 'yat-add-payment-method-common',
  templateUrl: './add-payment-method-common.component.html',
  styleUrls: ['./add-payment-method-common.component.scss']
})
export class AddPaymentMethodCommonComponent {
  constructor(private activatedRoute: ActivatedRoute, private addPaymentMethodService: AddPaymentMethodService) {}

  @Input()
  showWalletButtons: boolean = false;

  @Input()
  walletButtonsTemplate?: TemplateRef<any>;

  stashedWallet: WalletPaymentMethodType | null = null;

  createPaymentMethod(type: PaymentMethodType): void {
    if (!this.showWalletButtons || isReusablePaymentMethodType(type)) {
      this.addPaymentMethodService.addPaymentMethodNavigation(type, this.activatedRoute, '../payment-method-selection');
    } else {
      this.stashedWallet = type;
    }
  }
}
